export default "__VITE_ASSET__DcmCz0gY__"